import _ from 'lodash';
import Service from './abstract';
import page from '../constants/pages/page';

const defaultWith = 'type,attributes,attributes.attribute';
const defaultOptionsFind = {
    order: 'created_at-DESC',
    with: defaultWith,
    pageSize: page.pageSize
};

class Products extends Service {
    constructor () {
        super('products');
    }

    get fullWith () {
        return defaultWith;
    }

    get defaultOptionsFind () {
        return _.merge({}, super.defaultOptionsFind, defaultOptionsFind);
    }

    changeStatus (data = {}) {
        const status = {
            url: `${this.basePath}/products/changeStatus`,
            data
        };

        return this.put(status).then(response => response);
    }
}

export default new Products();
